import { createFileRoute } from '@tanstack/react-router';
import { choicesReadGuard } from '@bmwe/ui';
import { ChoiceTypeManagement } from '../../../features/choices/choiceTypeManagement';

export const Route = createFileRoute('/auswahlfelder/transportrouten-vorgang/')(
  {
    component: () => (
      <ChoiceTypeManagement
        choiceTypeKey="DossierTransportationTypes"
        returnRoute="/auswahlfelder/dossierTransportationTypes"
      />
    ),
    beforeLoad: choicesReadGuard,
  },
);

export const DossierTransportationTypesRoute = Route;
